export enum Language {
    CATALAN,
    SPANISH,
    ENGLISH,
    FRENCH,
    GERMAN,
    ITALIAN,
    NETHERLANDS,
    PORTUGUESE,
    RUSSIAN
}